<template>
  <div class="content-body" @click="collapseMenusOfChildren">
    <NftTop
      @refreshEvent="reloadChildren"
      projectname="Reaperville"
      ref="nftTop"
    />

    <Nft
      @refreshEvent="reloadChildren"
      :nftCA="contracts['nft']"
      projectname="Reaperville"
      pictureLink="https://raw.githubusercontent.com/Surviville/Reaperville/master/png-low-res/"
      ref="nft"
    />
  </div>
</template>

<script>
import Nft from "@/components/Nft.vue";
import NftTop from "@/components/NftTop.vue";

export default {
  name: "App",
  components: { Nft, NftTop },

  data() {
    return {
      contracts: {},
    };
  },
  methods: {
    reloadChildren: function () {
      this.$refs.nftTop.reload();
      this.$refs.nft.reload();
    },

    collapseMenusOfChildren: function () {
      this.$refs.nftTop.collapseMenus();
      this.$refs.nft.collapseMenus();
    },
  },

  mounted: function () {
    this.contracts["nft"] = window.ca["reaper"];
  },
};
</script>
